/**
 * Génère les N derniers mois au format { key, value, text }
 * value: "YYYY-MM" (ex: "2026-02")
 * text: "février 2026"
 */
export const generateMonthOptions = (count = 6) => {
  const options = [];
  const now = new Date();
  for (let i = 0; i < count; i += 1) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    options.push({
      key: `${year}-${month}`,
      value: `${year}-${month}`,
      text: d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' }),
    });
  }
  return options;
};

export const MONTH_OPTIONS = generateMonthOptions(6);

export const getCurrentPeriod = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
};
